export function getPayload(a_token) {
  try {
    if (!a_token) throw new Error('Empty token');

    let a_token_array = a_token.split('.');
    if (a_token_array.length !== 3) throw new Error('Invalid token format');

    let payload = a_token_array[1];
    let decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/')); // JWT использует URL-safe Base64

    return JSON.parse(decoded);
  } catch (error) {
    return null;
  }
}
